export const gqlQueryParams = (query: string, variables?: Record<string, unknown>) => {
  return {
    query: query,
    variables: variables
  };
};


/*
usage:
const someMutationOrQueryParms = gqlQueryParams(gqlDoc, variables: {someKey: someVal})
*/